<template>

   <spinner v-if="!loaded" ></spinner>

    <div class="template-padding container" v-else-if="loaded"  > 
        
        <div class="row" >
            <div class="col-12 text-left" >
                <router-link :to="{name: 'Business Accelerator' }" class="not-active text-left btn btn-transparent border-none btn-sm" > 
                    <font-awesome-icon icon="arrow-circle-left" ></font-awesome-icon> Back 
                </router-link>
            </div>
        </div>
        
        <div class="col-12 col-md-10 offset-md-1 p-0 mt-3" >
            <img src="@/assets/images/business_accelerator_1200x628-01.png" class="w-100" />
        </div>
        
        <div class="text-justify mt-5 mb-3 h3" style="line-height: 1.5;" >

        </div>
        
        <div class="row mt-5 mb-5 text-center m-0 alert alert-info pt-4 pb-4"  >
            <div class="col-12 col-md text-center text-md-left pt-2" >
                <h1 class="h1 font-weight-bold" > Download your ready-to-fill Blueprint </h1>
            </div>
            <div class="col-12 col-md text-center text-md-right mt-4 mt-md-0" >
                <a href="https://theatlass.com/ebooks/business-accelerator/02.1%20-%20Blueprint%20-%20Sales%20Page%20Template.pdf" target="_blank" class="btn btn-primary pl-5 pr-5 border-radius" > Download Blueprint </a>
            </div>
        </div>
        
        <!-- ACADEMY -->
        <div class="accordion mt-5" role="tablist">
            
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-0 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Introduction
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion0" > {{ calculateRead('accordion0') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-0"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion0" >
                        
                        Today we’re gonna talk about how to write high converting sales pages. We’re not gonna cover the technical part, you can use whatever software or drag-and-drop tools you like.
                        <br><br>
                        We’re gonna cover the key elements of a sales page that will guarantee conversions. 
                        <br><br>
                        Keep in mind that you already crafted many of the elements below in the previous step, for your sales offer,  so you can just use those. They might require some minor tweaks, but the essence is there.

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-1 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Top Banner
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion1" > {{ calculateRead('accordion1') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-1"  accordion="my-accordion" role="tabpanel" class="p-3"  >
                    <b-card-body ref="accordion1">
                        
                            This is normally the first thing you see when you land a page, consisting of a big bold headline and a sub-headline. The first thing you see before you scroll.
                            <br><br>
                            This is very important because the majority of people that land on your page will leave in the first 15 seconds so the decision to stay or quit is dedicated by this top banner.
                            <br><br>
                            Imagine you open a website or funnel and you read the first sentence. If that does not get your attention, you will not check the rest of the page. That first headline needs to draw people in.
                            <br><br>
                            It must have a big clear headline to attract people
                            A subine verifies and strengthens the benefits of using your service
                            Must be optimized for mobile and desktop to fit in the initial window, before you scroll 
                            <br><br>
                            A bad headline would be Welcome to my brand or welcome to my program.
                            <br><br>
                            <h1 class="h2 font-weight-bold pl-3 mb-2" >Headline</h1>
                            Get a [benefit] for [compelling offer]
                            [Benefit] in X days or Your Money Back
                            <br><br>
                            <h1 class="h2 font-weight-bold pl-3 mb-2" >Sub-headline</h1>
                            How my proven system can help you [benefit] in X days
                            Work With Us to [benefit] to Set Your Business Up for Success!

                    </b-card-body>
                </b-collapse>
            </b-card>
            
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-2 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        The Story
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            
                            <span id="accordion2" > {{ calculateRead('accordion2') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-2"  accordion="my-accordion" role="tabpanel" class="p-3">
                    <b-card-body ref="accordion2" >
                        
                        Create a compelling, relatable story that hits on your reader’s pain points (focus on ONE emotion).
                        <br><br>
                        Cast the reader into the story.
                        <br><br>
                        Hit their emotions / pains and resonate with them or paint picture of they bright happy future
                        <br><br>
                        Don’t flip between pain and fix, pain and fix, focus on 1 emotion. Keep the positivity
                        You can talk about you or other people who failed in the past, it’s not their fault, but this will help them succeed. 
                        <br><br>
                        Keep the reader engaged with each line. Each sentence must sell the next
                        <br><br>
                        A good practice is to write the sales page and then read it and attack it, attack every sentence and correct it. If it’s not wow and engages you to read the next one, either change it or rephrase it.
                        <br><br>
                        Build trust, make them resonate with the story.
                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            
            <!-- USP -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-3 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Benefits
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            
                            <span id="accordion3" > {{ calculateRead('accordion3') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel" class="p-3">
                    <b-card-body ref="accordion3" >
                        
                        Now that you set the scene and introduced the idea that you are the solution, go over the benefits to the consumer.
                        <br><br>
                        Ensure you cover real benefits of their pain points, not just random ideas in your head
                        <br><br>
                        You can keep the product or service a secret which will be revealed later, but make sure you introduce the benefits. “Is this a course, is this a tool, what is it?”
                        <br><br>
                        Use bullet points or pictures with titles, it’s more visual and appealing.
                        <br><br>
                        You already wrote the pain points for each avatar, so you can just flip them and write the benefits.


                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- USP -->
            
            <!-- Benefits and outcomes -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-4 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Testimonials & Social Proof
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            
                            <span id="accordion4" > {{ calculateRead('accordion4') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel" class="p-3">
                    <b-card-body ref="accordion4" >
                        
                        If they get to this section, they are intrigued by the idea, but maybe they lack trust. They clicked on your ad, or your instagram account, they don’t know who you are. That’s why you need social proof.
                        <br><br>
                        Social proof is the most powerful marketing technique. This shows that others have joined the program or service you are offering and had great results.
                        <br><br>
                        Make sure to use a video, or screenshots of results as opposed to just a plain text as they can be perceived as fake.
                        <br><br>
                        The real bonus if the testimonials cover the pain points of the avatar. When you are asking for a testimonial, make sure to tell them “hey, can you please make sure to cover these 3 key pain points”.
                        <br><br>
                        Make sure the testimonials are real videos or photos, not stock. If you don’t have any testimonials, you can talk to 10 people and give them the service or product for free and ask them for a testimonial after 2 or 4 weeks or give them the tool for free for 2 weeks in exchange for a testimonial.

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Benefits and outcomes -->
            
            <!-- Timeline -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-5 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Call Out The Avatar
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            
                            <span id="accordion5" > {{ calculateRead('accordion5') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel" class="p-3">
                    <b-card-body ref="accordion5" >
                        
                        If you already covered the above, your visitors might be wondering if they can get the same results, so make sure to confirm to your avatar that this service is for them.
                        <br><br>
                        - Just describe your avatar, you can get it from the Avatar section we talked about. Start by listing those traits:
                        <br>- This is perfect for if you watch ..
                        <br>- This is perfect if you have issues with your ads
                        <br>- This is perfect for marketers running ads
                        <br>- This is perfect for agency owners 
                        <br>- This is perfect if you run ads on Facebook / Google
                        <br>- This is perfect if you failed at …
                        <br>- This is perfect if you want to scale your business
                        <br><br>
                        You can get so in depth that they say “they are speaking to me, OMG!”. If you get can get that out of them, you will have more conversions because they will feel like you are speaking to them through the computer.
                        <br><br>
                        If you could show examples of customers / testimonials that overcame those pain points and issues, that would accelerate it.

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Timeline -->
            
            <!-- Urgency -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-6 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        What's Included
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            
                            <span id="accordion6" > {{ calculateRead('accordion6') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel" class="p-3">
                    <b-card-body ref="accordion6" >
                        
                        At this point, they are sold on the idea. They read the story, they have seen the benefits, they have proof from the testimonials, they know they are a good fit and it’s for them, now they are wondering what they get.
                        <br><br>
                        They are excited to see what the actual solution is, what’s included in the package and how it works. 
                        <br><br>
                        This is basically your offer stack. You got to wow them with value, make it clear that it’s a ridiculous deal and if they don’t act now, they are stupid and have everything to lose. 
                        <br><br>
                        Most people if they quit today, they will never come back. Make sure to include a ROI on this investment is insane. Is this price worth their investment?
                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Urgency -->
            
            <!-- Guarantee -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-7 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Future Casting
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            
                            <span id="accordion7" > {{ calculateRead('accordion7') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel" class="p-3">
                    <b-card-body ref="accordion7" >
                        
                        The idea of future casting is to help them see how their life can be in 3, 6, 12 month once using the program or solution.
                        <br><br>
                        Now that they’ve seen your solution, what it is and what are the benefits, help them future cast their life when they use your product.
                        <br><br>
                        Paint a picture showing them where they will be with this product.
                        <br><br>
                        Get into deep emotion that touches their pain points
                        <br><br>
                        “Just imagine … “ how when you use our system, you will save more time and turn more leads into customers
                        <br><br>
                        Make sure to explain they have a few options:
                        <br> - Do nothing and stay the same or fail 
                        <br> - Or take action and progress 
                        <br><br>
                        Emphasize that if they don’t take action, they will either stay the same or worse, because if you stay in the comfort zone and not take action, usually things get worse.
                        <br><br>
                        This is future casting and it’s very powerful copy that makes people convert
                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Guarantee -->
            
            <!-- Price -->
            <!--
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-8 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        The Plan
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            
                            <span id="accordion8" > {{ calculateRead('accordion8') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel" class="p-3">
                    <b-card-body ref="accordion8" >
                        
                        List the steps the customers need to take in order to either purchase, get access to or achieve the benefits listed above.
                        <br><br>
                        Try not to add more than 5, as it could come as too complex. Between 3-5 should do the job.
                        <br><br>
                        You can also give it a cool name that is easy to remember, such as “The 5 Easy Steps to [BENEFIT]”.

                    </b-card-body>
                </b-collapse>
            </b-card>
            -->
            <!-- Price -->
            
            <!-- The Plan -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-9 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        The Plan
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            
                            <span id="accordion9" > {{ calculateRead('accordion9') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-9" accordion="my-accordion" role="tabpanel" class="p-3">
                    <b-card-body ref="accordion9" >
                        
                        In this section, we are going to list the steps the customers need to take in order to either purchase, get access to or achieve the benefits listed above.
                        <br><br>
                        People trust a guide with a plan. Giving them a plan beforehand that is easy to follow can give them the extra boost they need to make the purchase.
                        <br><br>
                        Try not to complicate it. Don’t list more than 5 steps, as it may seem complex and hard to follow. Listing between 3 to 5 steps should suffice. 
                        <br><br>
                        You can also give it a name that is easy to remember, such as “The 5 Easy Steps”.

                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- The Plan -->
            
            <!-- Risk & Reward -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-10 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        The Price & Price Justification
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            
                            <span id="accordion10" > {{ calculateRead('accordion10') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-10" accordion="my-accordion" role="tabpanel" class="p-3">
                    <b-card-body ref="accordion10" >
                        
                        Price is always the biggest objection if you haven’t sold your product or service correctly. If you’ve done a good job, price will not be an objection.
                        <br><br>
                        Verify the offer stack and how basically they are stealing from you.


                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Risk & Reward -->
            
            <!-- Offer Stack -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-11 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Guarantee
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            
                            <span id="accordion11" > {{ calculateRead('accordion11') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-11" accordion="my-accordion" role="tabpanel" class="p-3">
                    <b-card-body ref="accordion11" >
                        
                        Comes either right before or after the price. A great way to stand out is to make the guarantee so bold, it scares you. 
                        <br><br>
                        Even with a guarantee, you make far more money in extra sales than you lose.
                        <br><br>
                        Make it clear, simple and strong.
                        <br>
                        <br> More sales in 30 days or your money back
                        <br> Fix your ads in 14 days or your money back
                        <br> Lose x pounds in 30 days
                        <br><br>
                        If your industry doesn’t normally do it, figure out a way to be first, it really boosts sales.
                        Nobody offers I guarantee, except me.
                        <br><br>
                        You can also add a 10% to your price if you add a bold guarantee, in the end it will make you gain more then you lose on refunds. 

                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Offer Stack -->
            
            <!-- Offer Stack -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-12 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        More Social Proof
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            
                            <span id="accordion12" > {{ calculateRead('accordion12') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-12" accordion="my-accordion" role="tabpanel" class="p-3">
                    <b-card-body ref="accordion12" >
                        
                        You cannot have enough social proof or testimonials. These additional proofs can push them over the edge and convert.
                        <br><br>
                        Especially if it covers any buying decisions they have right now, like price for example.

                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Offer Stack -->
            
            <!-- Offer Stack -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-13 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        More Social Proof
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            
                            <span id="accordion13" > {{ calculateRead('accordion13') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-13" accordion="my-accordion" role="tabpanel" class="p-3">
                    <b-card-body ref="accordion13" >
                        
                        Clarify their options using bullet points or something graphic: 3 options: 
                        <br>
                        <br> - go backwards
                        <br> - stay the same
                        <br> - progress
                        <br><br>
                        Be clear, to the point and touch these key points.
                        <br><br>
                        "You gotta act now" -> ( add another CTA )

                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Offer Stack -->
            
            <!-- Offer Stack -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-14 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        About Section
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            
                            <span id="accordion14" > {{ calculateRead('accordion14') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-14" accordion="my-accordion" role="tabpanel" class="p-3">
                    <b-card-body ref="accordion14" >
                        
                        This is the part where you can brag about you or your business. Most people don’t care about the brand, especially if it’s not that famous or just starting out. I’m sure this is not what you want to hear, that’s what I thought as well, but they really don’t.
                        <br><br>
                        Show that passion you have for them, the product and the industry and make sure you establish yourself as the EXPERT.

                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Offer Stack -->
            
            <!-- Offer Stack -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-15 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        FAQ
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            
                            <span id="accordion15" > {{ calculateRead('accordion15') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-15" accordion="my-accordion" role="tabpanel" class="p-3">
                    <b-card-body ref="accordion15" >
                        
                        Cover all pain points here: list them out and write the answers to fix them
                        <br><br>
                        Make sure to:
                        <br>
                        1. Cover the guarantee
                        <br>
                        2. Destroy price objections
                        <br>
                        3. Make it long and in depth, but easy to navigate.
                        <br>
                        4. Challange them and remove any doubters: "If you think x is a lot for […], then you’re probably not a good fit."     
                        <br>                                           
                        5. Cover technical

                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Offer Stack -->

          </div>
        <!-- ACADEMY -->
        
        <div class="mt-5 mb-5 h2 text-center"  >
            
            <a href="https://theatlass.com/ebooks/business-accelerator/02.1%20-%20Blueprint%20-%20Sales%20Page%20Template.pdf" target="_blank" class="btn btn-primary pl-5 pr-5 border-radius" > Download Blueprint </a>
            
        </div>
        
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
    
export default{
    name: "ACADEMY_sales_offer",
    props:["APPKEY"],
    components:{
    },
    data () {
        return {
            loaded: false,
            text: 'Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven not heard of them accusamus labore VHS.'
        }
    },
    mounted(){
        this.loaded = true;
    },
    methods:{
        openRow(params){
            
            let user =  Cookies.get('user')
            user = JSON.parse( atob( user ) )
            
            let page = params.row.Icon;
            let ID = params.row.ID;
            
            
            
            
        },
        returnDate(a){
            //return this.$moment.unix(a).format( 'MMM D, HH:mm' )
            return helper.formatDate( a, 'MMM D, HH:mm' )
        },
        calculateRead( target ){
            
            //console.log( ev )
            setTimeout( function(){
                
                //console.log( this.$refs )
                //console.log( this.$refs[target].innerHTML )                
                
                let ev = this.$refs[target].innerHTML
                
                const wordsPerMinute = 150; // Average case.
                let result;
                
                let textLength = ev.split(" ").length; // Split by words
                if(textLength > 0){
                    let value = Math.ceil(textLength / wordsPerMinute);
                    result = `~${value} min read`;
                }
                //return result
                //this.$refs[target].appendChild( result )
                document.getElementById(target).innerHTML = result;
                
            }.bind(this), 400 )
                
        }
    },
    computed: {
        
    },
    created: function () {

    },
    
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/templates/Academy/courses/business-accelerator/02-sales-page.vue